/**
 * ArticleContent - blog article body wrapper; handles market-tag visibility gating.
 * Custom element: <article-content>
 *
 * Attributes (from $info):
 *   markets  String  -
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class ArticleContent extends ThemeComponent {
  init() {
    // Market gating moved server-side (snippets/article-market-gate.liquid): the page
    // arrives already gated, so the /404 redirect is gone. The element stays registered
    // because theme.js lazy-loads this file by name via the import map.
  }
}
setFunctionName(ArticleContent, "ArticleContent");
const propertyTypes = {
  String
};
ArticleContent.prototype.$name = "ArticleContent";
ArticleContent.prototype.$info = JSON.parse('{"name":"ArticleContent","meta":{"isLegacy":false,"selector":"article-content"},"props":[{"attr":"markets","reflectAttr":false,"propertyKey":"markets","propertyType":"String","propertyTypeName":"String","propertyTsTypeName":"string"}],"refs":[]}');
ArticleContent.prototype.$info.component = ArticleContent;
for (const prop of ArticleContent.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Article/ArticleContent.ts", {
  ArticleContent: ArticleContent
}, void 0);